export function getMediaMimeTypeFromUrl(url?: string): {
  kind: "image" | "video";
  mime: string;
} | null {
  if (!url) {
    return null;
  }
  const extension = url.split(".").pop();

  if (!extension) {
    return null;
  }

  const imageMimeTypes: Record<string, string> = {
    // Images
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    svg: "image/svg+xml",
    bmp: "image/bmp",
    ico: "image/x-icon",
    avif: "image/avif",
  };
  const videoMimeTypes: Record<string, string> = {
    // Videos
    mp4: "video/mp4",
    webm: "video/webm",
    ogg: "video/ogg",
    mov: "video/quicktime",
    avi: "video/x-msvideo",
    mkv: "video/x-matroska",
    flv: "video/x-flv",
  };

  let mime = imageMimeTypes[extension];
  if (mime) {
    return {
      kind: "image",
      mime,
    };
  }
  mime = videoMimeTypes[extension];
  if (mime) {
    return {
      kind: "video",
      mime,
    };
  } else {
    return null;
  }
}
